module.exports = __webpack_public_path__ + "img/pariciones.0c763a90.svg";